export type MessageTemplateTransport = "email" | "whatsapp";

export enum MessageTemplateType {
  UNKNOWN = "unknown",
  CAMPAIGN = "campaign"
}

export enum MessageTemplateScope {
  TENANT = "tenant",
  ACCOUNT = "account",
  DOMAIN = "domain"
}

export interface MessageTemplate<T> {
  id: string;
  account?: string;
  tenant?: string;
  name: string;
  scope?: MessageTemplateScope;
  type: MessageTemplateType;
  transport?: MessageTemplateTransport;
  modules?: T[];
  subject?: string;
  content: string;
  deleted: boolean;
  createdBy?: {
    id: string;
    name: string;
  };

  createdAt: string;
  updatedAt?: string;
  deletedAt?: string;
}
